<!-- Modal Backdrop -->
<div
  *ngIf="isOpen"
  class="modal-backdrop"
  (click)="onBackdropClick($event)">

  <!-- Modal Container -->
  <div class="modal-container">

    <!-- Modal Content -->
    <div class="modal-content">

      <!-- Warning Icon -->
      <div class="warning-icon-container">
       <span class="material-symbols-outlined text-[#F40034] text-2xl font-semibold">
warning
</span>
      </div>

      <!-- Title -->
      <h2 class="modal-title">{{ title }}</h2>

      <!-- Message -->
      <p class="modal-message">{{ message }}</p>

      <!-- Separator Line -->
      <div class="modal-separator"></div>

      <!-- Buttons -->
      <div class="modal-buttons">
        <app-custom-button
          [text]="cancelText"
          backgroundColor="#FFFFFF"
          borderColor="#e5e7eb"
          textColor="#111928"
          hoverBackgroundColor="#DFE1EC"
          [fullWidth]="true"
          (click)="onCancel()">
        </app-custom-button>

        <app-custom-button
          [text]="confirmText"
          backgroundColor="#F40034"
          borderColor="#F40034"
          hoverBackgroundColor="#B5062C"
          hoverTextColor="#FFFFFF"
          [fullWidth]="true"
          [loading]="loading"
          [disabled]="loading"
          (click)="onConfirm()">
        </app-custom-button>
      </div>
      </div>

    </div>
  </div>

